import { validatenull } from '@/views/visual/dataScreen/js/echart/util';
export var uuid = function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";

  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }

  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010

  s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01

  s[8] = s[13] = s[18] = s[23] = "-";
  var uuid = s.join("");
  return uuid;
};
export var createFile = function createFile() {
  return {
    "title": "文件夹",
    "name": "文件夹",
    "index": uuid(),
    "children": []
  };
};
export var compare = function compare(propertyName) {
  return function (object1, object2) {
    var value1 = object1[propertyName];
    var value2 = object2[propertyName];

    if (value2 < value1) {
      return -1;
    } else if (value2 > value1) {
      return 1;
    } else {
      return 0;
    }
  };
};
export var funEval = function funEval(value) {
  return new Function("return " + value + ";")();
};
export var getFunction = function getFunction(fun, def) {
  if (!validatenull(fun)) {
    try {
      return funEval(fun);
    } catch (_unused) {
      return function () {};
    }
  } else if (def) return function () {};
};
export var getJson = function getJson(str) {
  if (validatenull(str)) return {};else if (typeof str == "string") {
    try {
      return JSON.parse(str);
    } catch (_unused2) {
      return {};
    }
  } else {
    return str;
  }
};
export var checkUrl = function checkUrl(url) {
  var reg = /http(s)?:\/\/([\w-.]+)+(:[0-9]+)?.*$/;

  if (!reg.test(url)) {
    return false;
  } else {
    return true;
  }
};